import React, {ReactNode} from 'react';

import {
  Select as MuiSelect,
  FormHelperText,
  FormControl,
  InputLabel,
  MenuItem,
} from '@material-ui/core';


export default function Select(props) {
  const {
    name,
    label,
    content,
    children,
    required,
    multiple,
    errorText,
    isError,
    inputLabelProps,
    formControlProps,
    menuItemProps,
    idKey = 'id',
    nameKey = 'name',
    ...restSelectProps
  } = props;

  //if (!content && !children) {
  //  throw new Error('Please specify either children or data as an attribute.');
  //}

  const {variant} = restSelectProps;
  const labelId = `select-input-${name}`;

  return (
    <FormControl
      required={required}
      error={isError}
      fullWidth={true}
      variant={variant || 'outlined'}
      {...formControlProps}
    >
      {!!label && (
        <InputLabel id={labelId} {...inputLabelProps}>
          {label}
        </InputLabel>
      )}
      <MuiSelect
        label={label}
        labelId={labelId}
        {...restSelectProps}
      >
        {content
          ? content.map(item => (
            <MenuItem
              value={item[idKey]}
              key={item[idKey]}
              disabled={item.disabled}
              {...menuItemProps}
            >
              {item[nameKey]}
            </MenuItem>
          ))
          : children}
      </MuiSelect>
      {!!isError && !!errorText && <FormHelperText>{errorText}</FormHelperText> }
    </FormControl>
  );
}
